import { assert_array_typeof_string, assert_instanceof } from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { FIELD_GRID2D_MODE__base } from '../_base/FIELD_GRID2D_MODE__base';
import { DECORATOR__field_not_linked } from '../_primitives/_base/DECORATOR__field_not_linked';
import { FIELD__list_token } from '../_primitives/list/FIELD__list_token';
import { FIELD__token } from './FIELD__token';

export class FIELD_GRID2D_MODE__token_vs_token extends FIELD_GRID2D_MODE__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_GRID2D_MODE__TOKEN_VS_TOKEN;

  /*
   *
   */
  tokens_pairs!: string[][];
  tokens: string[];

  /*
   *
   */

  //todo: finish
  // @FIELD_PRIMITIVE__int.init_as_field(
  //   {
  //     value: CONSTANTS__shared.NUMBER_EMPTY_VALUE,
  //     value_range: DTO__number_range.MINUS_ONE.clone(),
  //     values_allowed: DTO__number_range.MINUS_ONE.clone(),
  //     //
  //     slider_step: 1,
  //     slider_step_values: [1, 2, 3, 4, 5],
  //   },
  //   { ui__has_component: false, grid2d__can_be_dimension: false },
  // )
  // tokens_positions!: FIELD_PRIMITIVE__int;

  /*
   *
   */

  get_grid2d_side_size() {
    return Math.max(this.tokens.length, 1);
  }

  get grid2d_dimension_values() {
    return this.tokens_pairs;
  }

  /*
   *
   */

  constructor() {
    super();

    this.tokens_pairs = [];
    this.tokens = [];
  }

  @DECORATOR__field_not_linked()
  init_tokens(tokens: FIELD__token[]) {
    this.tokens_pairs = [];

    this.tokens = tokens.map(item => item.word_english.get_value());

    for (let y = 0; y < this.tokens.length; y++) {
      const token_y = this.tokens[y];

      for (let x = 0; x < this.tokens.length; x++) {
        const token_x = this.tokens[x];

        let pair = [];
        pair.push(token_y);

        if (token_y != token_x) pair.push(token_x);

        this.tokens_pairs.push(pair);
      }
    }

    if (this.tokens_pairs.is_empty()) this.tokens_pairs = [[]];

    /*
     *
     */

    //todo:finish
    // if (this.tokens_pairs.is_empty()) {
    //   this.tokens_pairs.push([]);
    //   this.tokens_positions.set_value_range(DTO__number_range.MINUS_ONE.clone());
    //   this.tokens_positions.values_allowed = DTO__number_range.MINUS_ONE.clone();

    //   this.tokens_positions.set_value(DTO__number_range.MINUS_ONE.min);
    // } else {
    //   let values_allowed = new DTO__number_range(1, this.tokens.length);
    //   this.tokens_positions.values_allowed = values_allowed.clone();

    //   let values_range_current = this.tokens_positions.get_value_range();

    //   let value_range_new = values_allowed.clamp_range(values_range_current);
    //   this.tokens_positions.set_value_range(value_range_new);

    //   this.tokens_positions.set_value(value_range_new.min);
    // }
  }

  @DECORATOR__field_not_linked()
  grid2d_dimension__set_value(tokens_pair: any) {
    assert_array_typeof_string(tokens_pair);

    this.tokens = [...tokens_pair];
    this.tokens_pairs = [[]];
  }

  @DECORATOR__field_not_linked()
  grid2d_dimension__apply_for(graph: DTO_GRAPH__instance) {
    let fields_map = graph.fields__get_map();
    let tokens_list = fields_map.values().find_or_assert(field => field instanceof FIELD__list_token);
    assert_instanceof(tokens_list, FIELD__list_token);

    tokens_list.items = tokens_list.get_tokens_by_words_english(this.tokens);
    tokens_list.field_name_and_path__fill_for_children();

    graph.field__replace(tokens_list);
  }
}
